module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-6-41d9302708402c6b3042f97e6833c14e.jpg";